import * as React from 'react';
import { DatePicker } from 'wix-ui-tpa';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';
import Backdrop from '../UI/Backdrop/Backdrop';
import { st, classes } from './WeeklyPickerPopup.st.css';
import weekStarterArray from '../../../utils/weekStarterArray';
var WeeklyPickerPopup = function (_a) {
    var handleCloseClick = _a.handleCloseClick, locale = _a.locale, weekStarter = _a.weekStarter, onDateSelectHandler = _a.onDateSelectHandler;
    //@ts-ignore
    var firstButton = React.useRef();
    //@ts-ignore
    var lastButton = React.useRef();
    var onFirstReached = function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            lastButton.current.focus();
        }
    };
    var onLastReached = function (e) {
        if (!e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            firstButton.current.focus();
        }
    };
    return (React.createElement("div", { className: st(classes.DatePicker) },
        React.createElement(Backdrop, { onClick: handleCloseClick }),
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: firstButton, onKeyDown: onFirstReached })),
        React.createElement(DatePicker, { className: classes.root, onChange: onDateSelectHandler, 
            //@ts-ignore
            firstDayOfWeek: weekStarterArray.indexOf(weekStarter), locale: locale }),
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: lastButton, onKeyDown: onLastReached }))));
};
export default WeeklyPickerPopup;
//# sourceMappingURL=WeeklyPickerPopup.js.map